import { render, staticRenderFns } from "./RoutineBehavior.vue?vue&type=template&id=06231942&"
import script from "./RoutineBehavior.vue?vue&type=script&lang=js&"
export * from "./RoutineBehavior.vue?vue&type=script&lang=js&"
import style0 from "./RoutineBehavior.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports